export const fileSource = '自然资源部宁德海洋中心'
export const mapSource = '中央气象台'
export const fishSource = '自然资源部宁德海洋中心'
export const siteBaseUrl = window.location.origin
export const quickAccessMenuList = [
  {
    path: '/fu-ding',
    name: '福鼎海洋预报',
    icon: 'menu2'
  },
  {
    path: '/xia-pu',
    name: '霞浦海洋预报',
    icon: 'menu1'
  }
]
// 云图来源
export const nephogramSource = '浙江台风网[https://typhoon.slt.zj.gov.cn]'

// 台风来源
export const typhoonDataSource = 'https://cdn.oss.wushikj.com'

// 台风路由
export const typhoonApi = '/data'

export const stationMap = {
  福鼎: ['沙埕站', '前岐站', '秦屿站'],
  霞浦: ['三沙站', '北礵站', '东冲站']
}

export function buildWebsiteHashUrl(path = '') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${siteBaseUrl}/#${normalizedPath}`
}
